export default __webpack_public_path__ + "static/media/br.dd2df2ee.svg";